import { fmtPctValue } from '../../shared/format';
import { fmtNumber } from '../kit';

const hasNumber = (v) => v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v));

/**
 * The owner suggestion's evidence line: "74 messages · 74% answered" when the suggestion
 * carries messages and a reply rate, otherwise the server's own sentence (`why`),
 * verbatim. A suggestion with neither has no line. `withTasks` adds the delivered count
 * between them ("54 messages · 12 tasks delivered · 74% answered") when the server sends
 * it; it is opt-in because the client page's People card does not show it.
 *
 * @param {{messages_sent?:number, reply_rate?:number, tasks_delivered?:number, why?:string}} owner
 * @param {{withTasks?: boolean}} [options]
 * @returns {string|null}
 */
export const ownerStatsLine = (owner, { withTasks = false } = {}) => {
  if (hasNumber(owner?.messages_sent) && hasNumber(owner?.reply_rate)) {
    const sent = Number(owner.messages_sent);
    const parts = [`${fmtNumber(sent)} ${sent === 1 ? 'message' : 'messages'}`];
    if (withTasks && hasNumber(owner?.tasks_delivered)) {
      const delivered = Number(owner.tasks_delivered);
      parts.push(`${fmtNumber(delivered)} ${delivered === 1 ? 'task' : 'tasks'} delivered`);
    }
    parts.push(`${fmtPctValue(Number(owner.reply_rate), 0)} answered`);
    return parts.join(' · ');
  }
  return owner?.why || null;
};
